/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewsubjecten4Inputs */

const en_letterpreviewsubjecten4 = /** @type {(inputs: Letterpreviewsubjecten4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject: Pre-formal notice (interpelação amigável) — contracted work`)
};

const pt_letterpreviewsubjecten4 = /** @type {(inputs: Letterpreviewsubjecten4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject: Pre-formal notice (interpelação amigável) — contracted work`)
};

/**
* | output |
* | --- |
* | "Subject: Pre-formal notice (interpelação amigável) — contracted work" |
*
* @param {Letterpreviewsubjecten4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewsubjecten4 = /** @type {((inputs?: Letterpreviewsubjecten4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewsubjecten4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewsubjecten4(inputs)
	return pt_letterpreviewsubjecten4(inputs)
});
export { letterpreviewsubjecten4 as "letterPreviewSubjectEN" }